@if (profile) {
    <livechat-widget
      license="12447846"
      visibility="minimized"
      [customerName]="name"
      [customerEmail]="email"
      [group]="getCurrentLanguage() === 'ar' ? 3: 4"
    ></livechat-widget>
  }